import React from 'react';
import styles from './FrontDesk.module.css';

const statusStyles = {
  available: styles.badgeReserved,
  //occupied: styles.badgeAvailable,
  occupied: styles.badgeBooked,
};

function StatusBadge({ status }) {
  return (
    <div className={statusStyles[status.toLowerCase()] || styles.badgeDefault}>
      {status}
    </div>
  );
}

function ActionButton() {
  return (
    <div className="options-menu">
      <button className="options-button">⋮</button>
      <div className="dropdown-menu">
        <button>Edit</button>
        <button>Delete</button>
      </div>
    </div>
  );
}

export function Availtable({ availData }) {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeaderRow}>
        <div className={styles.tableHeader}>Room Number</div>
        <div className={styles.tableHeader}>Bed Type</div>
        <div className={styles.tableHeader}>Floor</div>
        <div className={styles.tableHeader}>Facilities</div>
        <div className={styles.tableHeader}>Housekeeping Status</div>
        <div className={styles.tableHeader}>Status</div>
        {/* <div className={styles.tableHeader}>Actions</div> */}
      </div>
      {availData.map((avail, index) => (
        <div key={index} className={styles.tableRow}>
          <div className={styles.tableCell}>{avail.room.room_number}</div>
          <div className={styles.tableCell}>{avail.room.bed_type}</div>
          <div className={styles.tableCell}>{avail.room.room_floor}</div>
          <div className={styles.tableCell}>{avail.room.room_facility}</div>
          <div className={styles.tableCell}>{avail.room.hk_status}</div>
          <div className={styles.tableCell}>
            <StatusBadge status={avail.room.status} />
          </div>
          {/* <div className={styles.tableCell}>
            <ActionButton />
          </div> */}
        </div>
      ))}
    </div>
  );
}
